import { registerComponent } from '@gig/magic-common';
import OfferComponent from './offer.vue.js';

var Offer = registerComponent(OfferComponent);

export { Offer };
